export const version = "bytes/5.0.4";
//# sourceMappingURL=_version.js.map